module.exports = __webpack_public_path__ + "img/mobile/SmartButton-skip/btn-nextp-up@3x.png?0.0.53";